type ExportCSVOptions<TData> = {
  filename?: string;
  excludeColumns?: (keyof TData | 'select' | 'actions')[];
  onlySelected?: boolean; // Optional - if you want to export a filtered subset
  selectedRows?: TData[]; // Used if onlySelected is true
};

export function exportToCSV<TData extends object>(data: TData[], opts: ExportCSVOptions<TData> = {}): void {
  const { filename = 'data', excludeColumns = [], onlySelected = false, selectedRows = [] } = opts;

  const exportData = onlySelected ? selectedRows : data;

  if (!exportData || exportData.length === 0) {
    return;
  }

  // Get headers from first row
  const headers = Object.keys(exportData[0]).filter(
    (key) => !excludeColumns.includes(key as keyof TData | 'select' | 'actions'),
  );

  const csvContent = [
    headers.join(','), // header row
    ...exportData.map((row) =>
      headers
        .map((header) => {
          const cell = row[header as keyof TData];
          if (typeof cell === 'string') {
            return `"${cell.replace(/"/g, '""')}"`; // Escape double quotes
          }
          return cell != null ? String(cell) : '';
        })
        .join(','),
    ),
  ].join('\n');

  const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  const downloadName = filename.toLowerCase().endsWith('.csv') ? filename : `${filename}.csv`;
  link.setAttribute('download', downloadName);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
